export const PRO_TRIAL_PROMO = "PROTRIAL";

const STORAGE_KEY = "paperclip-promo";

export const readStoredPromo = (): string | null => {
  try {
    return window.localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
};

export const storePromo = (promo: string): void => {
  try {
    window.localStorage.setItem(STORAGE_KEY, promo);
  } catch {
    // Private mode or a blocked storage API. Checkout proceeds without a trial.
  }
};

export const hasProTrialPromo = (searchPromo?: string | null): boolean =>
  searchPromo === PRO_TRIAL_PROMO || readStoredPromo() === PRO_TRIAL_PROMO;
